import {
  Column,
  CreateDateColumn,
  Index,
  PrimaryGeneratedColumn,
} from 'typeorm';

import { ENotificationType } from '../../account';
import { ApiProperty } from '../../codegen';
import {
  IsDate,
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
} from '../../validators';

@Index(['userId', 'createdAt'])
@Index(['userId', 'readAt'])
@Index(['dedupeKey'])
export class Notification {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @PrimaryGeneratedColumn()
  id: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsEnum(ENotificationType, { groups: ['error'] })
  @Column({ type: 'varchar', enum: ENotificationType, nullable: false })
  type: ENotificationType;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: false })
  message: string;

  @ApiProperty()
  @IsObject({ groups: ['error'] })
  @Column({ type: 'jsonb', nullable: false, default: {} })
  payload: Record<string, unknown>;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @CreateDateColumn({ type: 'timestamptz', precision: 3 })
  createdAt!: Date;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  readAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  expiresAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  dedupeKey?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  source?: string | null;
}
